//Saga Prototyping
import { takeEvery, put, call, fork } from 'redux-saga/effects';

import {
    POST_PROTOTYPING_UPLOAD_IMAGE,
    POST_PROTOTYPING_UPLOAD_IMAGE_SUCCESS,
    POST_PROTOTYPING_UPLOAD_IMAGE_FAILURE
} from './actionType';

import {

    postPrototypingUploadImageSuccess,
    postPrototypingUploadImageFailure
} from './action';

import {
    postUpdatePrototype
} from '../../helpers/fakebackend_helper';

function* postPrototypingUploadImageSaga({ payload }) {
    try {
        const response = yield call(postUpdatePrototype, payload);
        yield put(postPrototypingUploadImageSuccess(response));
    } catch (error) {
        yield put(postPrototypingUploadImageFailure(error));
    }
}

export function* watchPostPrototypingUploadImageSaga() {
    yield takeEvery(POST_PROTOTYPING_UPLOAD_IMAGE, postPrototypingUploadImageSaga);
}

function* PrototypingSaga() {
    yield fork(watchPostPrototypingUploadImageSaga);
}

export default PrototypingSaga;